module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/august/mainvisual-bg-sp_a0741b86ae760db049fbfb550ac20072.png";